/**
 * Convert TagOptions[] to string[]
 * @param options
 * @returns string[] array of TagOptions[] ids
 */
var tagOptionsToValues = function tagOptionsToValues(options) {
  return options.length ? options.map(function (option) {
    return option.id;
  }) : [];
};

export default tagOptionsToValues;